// Reusable test id constants
export const HOME = {
    emergentLink: "home-emergent-link",
};

export const TID = {
    heroDonate: "hero-donate-btn",
    heroJoin: "hero-join-btn",
    focusCard: (i) => `focus-card-${i}`,
    projectCard: (slug) => `project-card-${slug}`,
    newsCard: (slug) => `news-card-${slug}`,
};
